import {formatDurationRounded} from "@/pages/statuspages/consumption/utils/uptimeBarEvents.ts";
import classNames from "classnames";
import {IconType} from "react-icons";
import {FiAlertTriangle, FiCheck, FiTool} from "react-icons/fi";
import styles from "./InspireGlobalStatus.module.scss";
import {PulseIcon} from "./PulseIcon.tsx";

export enum GlobalStatusType {
  OPERATIONAL = "OPERATIONAL",
  ISSUES = "ISSUES",
  MAINTENANCE = "MAINTENANCE",
}

interface InspireGlobalStatusProps {
  status: GlobalStatusType | undefined;
  durationSecs: number | null;
}

const STATUS_CONFIG: Record<GlobalStatusType, {className: string; Icon: IconType; text: string}> = {
  [GlobalStatusType.OPERATIONAL]: {className: styles.operational, Icon: FiCheck, text: "All Systems Operational"},
  [GlobalStatusType.ISSUES]: {
    className: styles.issues,
    Icon: FiAlertTriangle,
    text: "Experiencing a major service disruption",
  },
  [GlobalStatusType.MAINTENANCE]: {className: styles.maintenance, Icon: FiTool, text: "Maintenance"},
};

export const InspireGlobalStatus = ({status, durationSecs}: InspireGlobalStatusProps) => {
  if (!status) return null;

  const {className, Icon, text} = STATUS_CONFIG[status];
  const shortDur = durationSecs != null ? formatDurationRounded(durationSecs) : null;

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.statusGroup}>
        <Icon className={styles.icon} />
        <span className={styles.statusText}>{text}</span>
      </div>
      {status === GlobalStatusType.OPERATIONAL && shortDur && (
        <div className={styles.duration}>
          <PulseIcon status="up" className={styles.pulseIconReset} /> For:{" "}
          <span className={styles.durationValue}>{shortDur}</span>
        </div>
      )}
    </div>
  );
};
